var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fill-height"},[(_vm.isDesktopView)?_c('HomePageDesktop'):_vm._e(),(_vm.isMobileView)?_c('HomePageMobile'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }